import { getUserObject, logout } from "./sessionmain";

export let topNavLogin: HTMLElement;

function updateHeaderContent() {
    const userObject = getUserObject();
    const firstNameElem = document.querySelectorAll<HTMLElement>('[name=top-nav-firstname]');
    const profileElem = document.querySelector<HTMLElement>('#top-nav-profile');
    const profileElemMobile = document.querySelector<HTMLElement>('#top-nav-profile_m');
    const footerSignoutElem = document.querySelector<HTMLElement>('#footer-signout');
    const navSignoutElem = document.querySelector<HTMLElement>('#top-nav-signout');
    const navSignoutElemMobile = document.querySelector<HTMLElement>('#top-nav-signout_m');
    const navLoginElem = document.querySelector<HTMLElement>('#top-nav-login');
    const mobileProfileMenu = document.querySelector<HTMLElement>('#top-nav-profile-menu_m');
    
    if (userObject.IsAuthenticated === true) {
        footerSignoutElem?.classList.remove('hidden');
        navLoginElem?.classList.add('hidden');
        profileElem?.classList.remove('md:hidden');
        profileElemMobile?.classList.remove('hidden');
        mobileProfileMenu?.setAttribute('data-expanded', 'true');
        footerSignoutElem?.addEventListener('click', signoutClicked);
        navSignoutElem?.addEventListener('click', signoutClicked);
        navSignoutElemMobile?.addEventListener('click', signoutClicked);
        firstNameElem.forEach(e => e.innerText = userObject.FirstName);
    }
    else {
        footerSignoutElem?.classList.add('hidden');
        navLoginElem?.classList.remove('hidden');
        profileElem?.classList.add('md:hidden');
        profileElemMobile?.classList.add('hidden');
    }
}

function accountLinkClicked(evt: Event) {
    const userObject = getUserObject();
    const elem = (<HTMLElement>evt.target);

    if (userObject.IsAuthenticated === false) {
        elem.classList.add('pointer-events-none');
        elem.classList.add('opacity-70');
    }
}

function signoutClicked() {
    logout();
}

function bindHeaderElements() {
    topNavLogin = document.querySelector<HTMLElement>('#top-nav-login') || new HTMLElement();
    topNavLogin?.addEventListener('click', accountLinkClicked);
}

export function updateSessionUI() {
    bindHeaderElements();
    updateHeaderContent();
}
